module.exports = __webpack_public_path__ + "static/media/entertain-applause.9060968e.vtt";